import React, { useMemo } from 'react';
import type { ColDef, GridReadyEvent } from 'ag-grid-community';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

ModuleRegistry.registerModules([AllCommunityModule]);

interface AppGridProps {
  gridRef: React.RefObject<AgGridReact<any> | null>;
  columnDefs: ColDef[];
  onCellClicked?: (params: any) => void;
  onGridReady?: (params: GridReadyEvent) => void;
  loading?: boolean;
}

const AppGrid: React.FC<AppGridProps> = ({ gridRef, columnDefs, onCellClicked, onGridReady, loading = false }) => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);

  const defaultColDef = useMemo<ColDef>(
    () => ({
      flex: 1,
      minWidth: 100,
      sortable: true,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      floatingFilter: true,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
      suppressHeaderFilterButton: true,
    }),
    []
  );

  const overlayComponentParams = useMemo(
    () => ({
      loading: { overlayText: 'Please wait while your data is loading...' },
      noRows: { overlayText: 'This grid has no data!' },
      noMatchingRows: { overlayText: 'Current Filter Matches No Rows' },
      exporting: { overlayText: 'Exporting your data...' },
    }),
    []
  );

  const localeText = useMemo(
    () => ({
      dateFormatOoo: 'mm/dd/yyyy',
    }),
    []
  );

  return (
    <div style={containerStyle}>
      <div style={gridStyle} className="ag-theme-quartz">
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          localeText={localeText}
          rowBuffer={0}
          rowSelection="multiple"
          overlayComponentParams={overlayComponentParams}
          rowModelType="infinite"
          cacheBlockSize={100}
          cacheOverflowSize={2}
          maxConcurrentDatasourceRequests={2}
          infiniteInitialRowCount={1}
          maxBlocksInCache={2}
          onGridReady={onGridReady}
          onCellClicked={onCellClicked}
          pagination={true}
          overlayNoRowsTemplate={'<span aria-live="polite" aria-atomic="true";pos>No data Available!</span>'}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default AppGrid;
